export default __webpack_public_path__ + "static/media/DocumentsImage.d0b14f89.svg";